import { Home, BarChart2, Trophy, Settings, Users, MessageCircle } from "lucide-react";
import { cn } from "@/lib/utils";
import { t } from "@/lib/i18n";

export type Tab = "home" | "halka" | "tally" | "messages" | "scoreboard" | "settings";

interface BottomNavProps {
  active: Tab;
  onNavigate: (tab: Tab) => void;
}

const tabs: { id: Tab; icon: typeof Home; labelKey: "nav_home" | "nav_halka" | "nav_tally" | "nav_messages" | "nav_score" | "nav_settings" }[] = [
  { id: "home", icon: Home, labelKey: "nav_home" },
  { id: "halka", icon: Users, labelKey: "nav_halka" },
  { id: "tally", icon: BarChart2, labelKey: "nav_tally" },
  { id: "messages", icon: MessageCircle, labelKey: "nav_messages" },
  { id: "scoreboard", icon: Trophy, labelKey: "nav_score" },
  { id: "settings", icon: Settings, labelKey: "nav_settings" },
];

export function BottomNav({ active, onNavigate }: BottomNavProps) {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-card/95 backdrop-blur-xl border-t border-border">
      <div className="max-w-lg mx-auto flex items-center justify-around py-2 px-2">
        {tabs.map(({ id, icon: Icon, labelKey }) => (
          <button
            key={id}
            onClick={() => onNavigate(id)}
            className={cn(
              "flex flex-col items-center gap-1 py-1.5 px-1.5 rounded-xl transition-all min-w-0",
              active === id
                ? "text-gold"
                : "text-muted-foreground hover:text-foreground",
            )}
          >
            <Icon
              size={20}
              strokeWidth={active === id ? 2.5 : 1.8}
              className={cn(active === id && "drop-shadow-[0_0_8px_rgba(232,160,32,0.5)]")}
            />
            <span className={cn("text-[9px] font-semibold truncate", active === id && "font-bold")}>
              {t(labelKey)}
            </span>
          </button>
        ))}
      </div>
      <div className="h-safe-area-inset-bottom" />
    </nav>
  );
}
